import { FormEvent, useEffect, useRef, useState } from "react";

import Button from "@components/button/button";
import { buttonTheme } from "@components/button/button-constants";
import Input from "@components/input/input";
import Modal from "@components/modal/modal";
import ModalTitle from "@components/modal/modal-title";

const FellowIntegrationDialog = ({
  open,
  initialApiDomain,
  isSaving,
  onClose,
  onSave,
}: {
  open: boolean;
  initialApiDomain?: string | null;
  isSaving: boolean;
  onClose: () => void;
  onSave: (apiKey: string, apiDomain: string) => void;
}) => {
  const [apiKey, setApiKey] = useState("");
  const [apiDomain, setApiDomain] = useState(initialApiDomain || "");
  const initialApiDomainRef = useRef(initialApiDomain);
  const wasOpenRef = useRef(open);

  initialApiDomainRef.current = initialApiDomain;

  useEffect(() => {
    if (open && !wasOpenRef.current) {
      setApiKey("");
      setApiDomain(initialApiDomainRef.current || "");
    }
    wasOpenRef.current = open;
  }, [open]);

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    onSave(apiKey.trim(), apiDomain.trim());
  };

  return (
    <Modal open={open} onClose={onClose}>
      <form onSubmit={handleSubmit} className="p-6">
        <ModalTitle onClose={onClose}>Connect to Fellow</ModalTitle>
        <div className="mt-6 space-y-4">
          <p className="text-sm text-gray-600">
            Enter the Fellow API key and API domain for this organization.
            Topicflow will use them to import Fellow meeting transcripts.
          </p>
          <Input
            autoFocus
            label="API key"
            name="fellow-api-key"
            type="password"
            value={apiKey}
            onChange={(event) => setApiKey(event.target.value)}
            autoComplete="off"
          />
          <Input
            label="API domain"
            name="fellow-api-domain"
            type="url"
            value={apiDomain}
            onChange={(event) => setApiDomain(event.target.value)}
            placeholder="https://api.fellow.app"
            autoComplete="off"
          />
        </div>
        <div className="mt-6 flex justify-end gap-2">
          <Button onClick={onClose} disabled={isSaving}>
            Cancel
          </Button>
          <Button
            type="submit"
            theme={buttonTheme.primary}
            disabled={isSaving || !apiKey.trim() || !apiDomain.trim()}
          >
            Save
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default FellowIntegrationDialog;
